import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendCompanyWithAdditionalInfomation,
} from "node-library/dist/portal";
import { Card, Divider } from "@mui/material";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import { FrontendContentPage } from "node-library/dist/constants";
import { FrontendSampleTestBatchOverview } from "node-library/dist/structures/frontendSampleTestBatchPageDefinitions";
import AnalystViewBatchRow from "./analystViewBatchRow";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	batchOverviews: Array<FrontendSampleTestBatchOverview>;
	user: FrontendUserInfo | undefined;

	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
	navigateToBatchDetailsPage: (
		batchId: string,
		fromPage: FrontendContentPage
	) => void;
}

export default function AnalystViewBatchTableListView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		company,
		batchOverviews,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		user,
		navigateToBatchDetailsPage,
	} = props;

	const headerItems = [
		{
			title: translation("Batches"),
		},
		{
			title: translation("Test"),
		},
		{
			title: translation("MethodId"),
		},
		{
			title: translation("Size"),
		},
		{
			title: translation("CreatedBy"),
		},
		{
			title: translation("DueDate"),
		},
		{
			title: translation("Status"),
		},
	];

	const batchRows: Array<React.ReactNode> = batchOverviews
		? batchOverviews.map(
				(batchOverview: FrontendSampleTestBatchOverview, index: number) => {
					return (
						<AnalystViewBatchRow
							company={company}
							key={batchOverview.testBatchId}
							batchOverview={batchOverview}
							user={props.user}
							goToViewBatchDetails={() => {
								navigateToBatchDetailsPage(
									batchOverview.testBatchId,
									FrontendContentPage.BATCH_PAGE
								);
							}}
						/>
					);
				}
		  )
		: [];

	const headerRowItems: React.ReactNode = headerItems.map((item) => {
		return (
			<div key={item.title} style={{ display: "flex", gap: "10px" }}>
				<Divider orientation="vertical" flexItem></Divider>
				<div
					className="typography-body-01"
					style={{
						color: NeutralColor.NEUTRAL_GREY_500,
						display: "flex",
						alignItems: "center",
						gap: "5px",
					}}
				>
					{item.title}
					{/* {item.sortColumnBy && (
						<SortArrowIcon
							sortOrder={sortOrder}
							notInUse={sortBy !== item.sortColumnBy}
						/>
					)} */}
				</div>
			</div>
		);
	});

	const batchRowContainer: React.ReactNode = (
		<Card className="common-card card-medium-padding">{batchRows}</Card>
	);

	return (
		<div>
			<div className="analyst-batch-list-view-row batch-list-view-header">
				{headerRowItems}
			</div>
			{batchRowContainer}
		</div>
	);
}
